import CoursesSection from "~/components/pages/courses/courses-section";
import BreadcrumbSection from "~/layout/public/bread-crumbs/bread-crumb-section";

const bcTitle = 'First Aid, Mental Health First Aid and Health & Safety Training';
const bcText = '<span class="bcSubTitle">Training Designed for You</span><br />Beyond industry standards, we customise courses to meet your specific needs.';
const description = "Constellation Training - Offering First Aid, Mental Health First Aid and Health & Safety training";
const url = '/about';



export default function CoursesIndex() {

    return (
        <>
            <BreadcrumbSection title={bcTitle} text={bcText} />
            <CoursesSection />
        </>
    );
}
